import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";

import AuthorizationComponent from "../Collections/AuthorizationComponent";
import { updateResourceSummary } from "../../redux-store/currentUserActions";


const AuthorizationComponentWithAutoSave = ({allowInheritFromParent}) => {
  const dispatch = useDispatch();
  const selectedSummary = useSelector((state) => state.user.selectedSummary);
  const [authorization, setAuthorization] = useState({});

  useEffect(() => {
    setAuthorization({
      authorization_type: selectedSummary?.authorization_type,
      authorization_value: selectedSummary?.authorization_value
    })
  }, [selectedSummary])

  const onAuthorizationUpdate = async (authorization) => {
    await dispatch(updateResourceSummary({
      id: selectedSummary?.id,
      summary: authorization
    }));
  }

  return (
    <div style={{height: '69vh'}} >
     <AuthorizationComponent
      allowInheritFromParent={allowInheritFromParent}
      authorization={authorization}
      onAuthorizationUpdate={onAuthorizationUpdate}
     />
    </div>
  );
};
export default AuthorizationComponentWithAutoSave;